import { render, staticRenderFns } from "./project-products-listing.vue?vue&type=template&id=0597a5ef&scoped=true&"
import script from "./project-products-listing.vue?vue&type=script&lang=js&"
export * from "./project-products-listing.vue?vue&type=script&lang=js&"
import style0 from "./project-products-listing.vue?vue&type=style&index=0&id=0597a5ef&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0597a5ef",
  null
  
)

export default component.exports